import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

const useMuiConfirmTheme = () => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => ({
      title: formatMessage({
        id: 'confirm.default.title',
        defaultMessage: 'Confirmation',
      }),
      description: formatMessage({
        id: 'confirm.default.description',
        defaultMessage: 'Are you sure?',
      }),
      confirmationText: formatMessage({
        id: 'button.confirm',
        defaultMessage: 'Confirm',
      }),
      cancellationText: formatMessage({
        id: 'button.cancel',
        defaultMessage: 'Cancel',
      }),
      contentProps: {
        dividers: false,
        sx: {
          textAlign: 'left',
          color: 'text.primary',

          '& .MuiDialogContentText-root': {
            color: 'text.primary',
          },
        },
      },
      confirmationKeywordTextFieldProps: {
        autoFocus: true,
        sx: { mt: 2 },
        slotProps: {
          htmlInput: {
            // makes input case-insensitive
            onInput: (e: React.FormEvent<HTMLInputElement>) => {
              const target = e.target as HTMLInputElement;
              target.value = target.value.toLowerCase();
            },
            autoComplete: 'off',
          },
        },
      },
      confirmationButtonProps: {
        color: 'primary',
        variant: 'contained',
      },
      cancellationButtonProps: {
        color: 'primary',
        variant: 'text',
        name: 'confirmModalCancelBtn',
      },
      dialogProps: {
        name: 'confirmModal',
        maxWidth: 'xs',
      },
    }),
    [formatMessage],
  );
};

export default useMuiConfirmTheme;
